import PropTypes from 'prop-types';
import { createContext } from 'react';

// project imports
import defaultConfig from '../config';
import useLocalStorage from '../hooks/useLocalStorage';

// initial state
const initialState = {
  ...defaultConfig,
  onChangeMode: () => { },
  onChangeFontFamily: () => { },
  onChangeBorderRadius: () => { },
  onReset: () => { }
};

// ==============================|| CONFIG CONTEXT & PROVIDER ||============================== //

const ConfigContext = createContext(initialState);

function ConfigProvider({ children }) {
  const [config, setConfig] = useLocalStorage('store', {
    fontFamily: initialState.fontFamily,
    borderRadius: initialState.borderRadius,
    mode: initialState.mode,
    presetColor: initialState.presetColor,
    outlinedFilled: initialState.outlinedFilled
  });

  // Debug logging
  console.log('⚙️ ConfigProvider - Current config:', config);

  // Ensure all properties exist (merge with defaults if localStorage has old structure)
  const mergedConfig = {
    fontFamily: config.fontFamily || initialState.fontFamily,
    borderRadius: config.borderRadius ?? initialState.borderRadius,
    mode: config.mode || initialState.mode,
    presetColor: config.presetColor || initialState.presetColor,
    outlinedFilled: config.outlinedFilled ?? initialState.outlinedFilled
  };

  const onChangeMode = (mode) => {
    console.log('⚙️ ConfigProvider - Setting mode to:', mode);
    setConfig({
      ...mergedConfig,
      mode
    });
  };

  const onChangeFontFamily = (fontFamily) => {
    setConfig({
      ...mergedConfig,
      fontFamily
    });
  };

  const onChangeBorderRadius = (event, newValue) => {
    setConfig({
      ...mergedConfig,
      borderRadius: newValue
    });
  };

  const onReset = () => {
    setConfig({ ...defaultConfig });
  };

  return (
    <ConfigContext.Provider
      value={{
        ...mergedConfig,
        onChangeMode,
        onChangeFontFamily,
        onChangeBorderRadius,
        onReset
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
}

export { ConfigProvider, ConfigContext };

ConfigProvider.propTypes = { children: PropTypes.node };
